import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { getAutoTargetReviewEndpoint } from '../../../common/endpoints';

export const postApproveAutoTargetReview = createApi(getAutoTargetReviewEndpoint, 'POST');

const ApproveAutoTarget = createSlice({
  name: 'ApproveAutoTarget',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postApproveAutoTargetReview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postApproveAutoTargetReview.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postApproveAutoTargetReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ApproveAutoTarget.reducer;